import { call, put, select, spawn } from 'redux-saga/effects';

import { updateRegFilingType } from '@api/filingTypes';
import { filingTypesSetModel } from '@models/filingTypes';
import { history, jurisdictionsRoutes } from '@routes';
import {
  filingTypesUpdateFailure,
  filingTypesUpdateSuccess,
} from '@store/entityJurisdictions/entityJurisdictionsDetail/filingTypes/filingTypes.reducer';
import { toastError, toastSuccess } from '@store/notifications';
import { filingNameSelector } from '@store/selectors/registrations';

import { filingTypesFetchSaga } from '../filingTypesFetchSaga';

export const filingTypesUpdateSaga = function* ({ payload }) {
  try {
    yield call(
      updateRegFilingType,
      payload.filingId,
      filingTypesSetModel({
        ...payload.data,
        filingId: payload.filingId,
        entityJurisdictionId: payload.entityJurisdictionId,
      })
    );

    const filingName = yield select(filingNameSelector, payload.data?.filingType);

    yield put([
      filingTypesUpdateSuccess(),
      toastSuccess({
        message: {
          defaultMessage: '{filingName} updated successfully.',
          id: 'pages.registrations.filing-types-update.notification.success',
        },
        values: {
          filingName,
        },
      }),
    ]);

    yield spawn(filingTypesFetchSaga, {
      payload: { entityJurisdictionId: payload.entityJurisdictionId },
    });

    yield call(
      history.replace,
      jurisdictionsRoutes.DETAIL.make({
        entityId: payload.entityId,
        entityJurisdictionId: payload.entityJurisdictionId,
      })
    );
  } catch (error) {
    const { fieldErrors, nonFieldErrors, hasNonFieldError, hasFieldError } = error.data || {};

    if (hasFieldError) {
      yield call(payload.setErrors, fieldErrors);
    }

    const filingName = yield select(filingNameSelector, payload.data?.filingType);

    yield put([
      toastError(
        hasNonFieldError
          ? {
              message: nonFieldErrors,
            }
          : {
              message: {
                defaultMessage: 'Failed to update {filingName}.',
                id: 'pages.registrations.filing-types-update.notification.error',
              },
              values: {
                filingName,
              },
            }
      ),
      filingTypesUpdateFailure(),
    ]);

    yield call(payload.setSubmitting, false);
  }
};
